import React from "react";

const Error = () => {
  return <h2>PAGE NOT FOUND</h2>;
};

export default Error;
